export const LOT_STATUSES = ["available", "pending"];

export function isPlaceholderPhoto(url: string | null | undefined): boolean {
  return !url?.trim() || /ai-placeholder|placeholder\.(svg|webp)|rv-placeholders|photos-coming-soon/i.test(url);
}

export function unitPhotos(images: string[] | null | undefined): string[] {
  return (images ?? []).filter((url) => !isPlaceholderPhoto(url));
}

export function placeholderCategory(type: string | null | undefined): string {
  const value = (type ?? "").toLowerCase().replace(/[-_]/g, " ");
  if (/toy hauler/.test(value)) return "toy-hauler";
  if (/fifth wheel|5th wheel/.test(value)) return "fifth-wheel";
  if (/class\s*a/.test(value)) return "class-a";
  if (/class\s*b/.test(value)) return "class-b";
  if (/class\s*c/.test(value)) return "class-c";
  if (/travel trailer|destination trailer/.test(value)) return "travel-trailer";
  return "generic";
}